import { types, actions } from './requests'
export const GETJOB_TYPES = {
    ...types('GETJOB'),
}
export const GETJOB_ACTIONS = {
    ...actions('GETJOB'),
}
